import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, FloatingLabel, Button, Spinner, Row, Col } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { LoginManager } from '../../core/login-manager';
import { settings } from '../../config/settings';

export default function Recover() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [sending, setSending] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setSending(true);
        const response = await LoginManager.recoverPassword(email);
        setSending(false);

        if (response.success === 1) {
            navigate('/reset');
        }
    }

    return (
        <Container
            fluid
            id="login-container"
            className="px-3"
        >
            <Row className="login-layout gx-5">
                <Col lg={6} className="login-hero mb-5 mb-lg-0">
                    <div className="hero-top d-flex justify-content-between align-items-center">
                        <div className="hero-logo d-flex align-items-center gap-2">
                            <img className="lv-brandmark" src={`${process.env.PUBLIC_URL}/favicon.svg`} alt="" />
                            <span className="fw-semibold">{settings.brand.name}</span>
                        </div>
                    </div>
                    <div className="hero-copy mt-5">
                        <p className="hero-eyebrow text-uppercase mb-2">{settings.brand.tagline}</p>
                        <h1 className="hero-title">
                            Recupera l’accesso al tuo account.
                        </h1>
                        <p className="hero-subtitle">
                            Inserisci l’email con cui ti sei registrato: ti invieremo il codice per impostare una nuova password.
                        </p>
                    </div>
                </Col>

                <Col lg={6}>
                    <div className="login-card">
                        <Form onSubmit={handleSubmit}>
                            <div className="text-start mb-4">
                                <p className="text-muted mb-1 small">Password dimenticata?</p>
                                <h3 className="fw-bold">{LanguageProvider.get('login.forgot')}</h3>
                                <p className="text-muted mb-0">
                                    {LanguageProvider.get('login.change_password')}
                                </p>
                            </div>

                            <FloatingLabel label="Email" className="mb-4">
                                <Form.Control
                                    type="email"
                                    placeholder="name@example.com"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    required
                                />
                            </FloatingLabel>

                            <Button
                                variant="dark"
                                type="submit"
                                className="w-100 d-flex justify-content-center align-items-center gap-2"
                                disabled={sending}
                            >
                                {LanguageProvider.get('login.send_forgot_password_key')}
                                {sending && <Spinner animation="border" size="sm" />}
                            </Button>

                            <div className="text-center mt-3">
                                <Button variant="link" className="p-0" onClick={() => navigate('/')}>
                                    {LanguageProvider.get('login.back_to_login')}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
